export const UMC_SUMBIT_PAYMENT = "UMC_SUMBIT_PAYMENT";
export const UMC_SUMBIT_PAYMENT_SUCCESS = "UMC_SUMBIT_PAYMENT_SUCCESS";
export const UMC_SUMBIT_PAYMENT_FAIL = "UMC_SUMBIT_PAYMENT_FAIL";
export const HIDE_ALERT_INFO_SUBMIT_FAIL = "HIDE_ALERT_INFO_SUBMIT_FAIL";

export const CLEAR_UMC_PAYMENT_SUPPORT_INFO = "CLEAR_UMC_PAYMENT_SUPPORT_INFO";

export const CANCEL_REDIRECT_TO_PAYMENT_SUPPORT_PAGE =
  "CANCEL_REDIRECT_TO_PAYMENT_SUPPORT_PAGE";

// export const UMC_URL_SUBMIT_PAYMENT = "/booking/insertmulti";
